import StatusBox from "./Elements/StatusBox";

interface StatusDescription {
    desc: string;
    statusType: "primary" | "success" | "warning" | "error";
}

function getMatchStatusDescription(isMatchToSelectedUser: boolean): StatusDescription {

    if (isMatchToSelectedUser) {
        return {
            desc: "Atanmış",
            statusType: "success"
        }
    } else {
        return {
            desc: "Atanmamış",
            statusType: "warning"
        }
    }
}

export function getMatchStatusInfo(isMatchToSelectedUser: boolean) {
    const {desc, statusType} = getMatchStatusDescription(isMatchToSelectedUser);
    return <StatusBox content={desc} statusType={statusType} />
}